import React, { useLayoutEffect, useRef } from 'react';
import { gsap } from '../../gsap';
import './infographics.scss';
import { lang } from '../lang';

function Infographic2() {
  const contentRef = useRef();
  const stat1Ref = useRef();
  const { stat, number } = lang.infographic[1];
  useLayoutEffect(() => {
    gsap.set(contentRef.current, {
      opacity: 0
    });

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach((entry) => {
          if (entry.intersectionRatio > 0.4) {
            gsap.to(contentRef.current, { opacity: 1, duration: 1, ease: 'ease-in' });
          }
        });
      },
      { threshold: [0, 0.4] }
    );
    observer.observe(stat1Ref.current);
  }, []);

  return (
    <div className="infographics__content infographics__content-1" ref={contentRef}>
      <div className="infographics__row">
        <div className="infographics__row__item">
          <div className="pinkgradient infographics__row__num">
            170<span className="infographics__row__num infographics__row__num--s">{number[0]}</span>
          </div>
          <p ref={stat1Ref} className="infographics__row__copy">
            {stat[0]}
          </p>
        </div>
        <div className="infographics__row__item">
          <div className="pinkgradient infographics__row__num">{number[1]}</div>
          <p className="infographics__row__copy">{stat[1]}</p>
        </div>
      </div>
      <div className="infographics__row">
        <div className="infographics__row__item">
          <div className="pinkgradient infographics__row__num">{number[2]}</div>
          <p className="infographics__row__copy infographics__row__copy-n">{stat[2]}</p>
        </div>
        <div className="infographics__row__item">
          <div className="pinkgradient infographics__row__num pinkgradient infographics__row__num--m">
            800
            <span className="infographics__row__num infographics__row__num--xs">{number[3]}</span>
          </div>
          <p className="infographics__row__copy">{stat[3]}</p>
        </div>
      </div>
    </div>
  );
}

export default Infographic2;
